<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<el-dialog
		class="custom-confirm-dialog"
		destroy-on-close
		:show-close="false"
		:close-on-click-modal="false"
		:visible.sync="isDialogActiveLocal"
		:title="isAgree ? `${$t('Actions.Agree')} ${$t('Actions.Approve')}` : `${$t('Actions.Reject')} ${$t('Actions.Approve')}`"
	>
		<div>
			<p class="mb-3" v-if="isAgree">{{ $t("ApproveConfirm") }}</p>
			<label> {{ $t(isAgree ? "Note" : "InputReasonReject") }} <span class="text-danger" v-if="!isAgree">*</span>:</label>
			<cbs-textarea
				class="mt-2"
				name="reason"
				type="textarea"
				v-model="value.reason"
				v-validate="{
					required: !isAgree
				}"
				:rows="3"
				:data-vv-as="$t('Reason')"
				:placeholder="isAgree ? $t('Placeholder.InputNote') : `${$t('Actions.Input')} ${$t('Reason').toLowerCase()}`"
			/>
			<span class="text-danger text-sm" v-show="errors.has('reason')">
				{{ errors.first("reason") }}
			</span>
			<CbsQuickReason :positive="isAgree" v-model="value.reason" />
		</div>

		<div class="flex justify-end -mx-6" slot="footer">
			<vs-button class="w-1/2 sm:w-1/3 font-bold text-solid-primary bg-transparent whitespace-no-wrap" type="flat" @click.stop="handleClickCancel">
				{{ $t("Actions.Cancel") }}
			</vs-button>
			<vs-button class="w-1/2 sm:w-1/3 font-bold ml-3 whitespace-no-wrap" @click.stop="handleClickConfirm">{{ $t("Actions.Confirm") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import CbsQuickReason from "@/components/cbs-quick-reason/CbsQuickReason.vue";

export default {
	name: "RequestApproveOrRejectConfirmDialog",
	components: { CbsQuickReason },
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => prop.hasOwnProperty("id") && prop.hasOwnProperty("reason") && prop.hasOwnProperty("notificationStepsConfig")
		},
		isAgree: {
			type: Boolean,
			required: true
		},
		isDialogActive: {
			type: Boolean,
			required: true
		}
	},
	emits: {
		onClickCancel: {},
		onClickConfirm: {}
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		}
	},
	methods: {
		handleClickCancel() {
			this.$emit("onClickCancel");
		},
		handleClickConfirm() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onClickConfirm", this.value);
				}
			});
		}
	}
};
</script>

<style></style>
